import { breakpointVal, iconOrderBefore, IconSvg } from '@graphcommerce/next-ui'
import { Box, darken, lighten } from '@mui/material'
import { UseAddProductsToCartActionFragment } from '@graphcommerce/magento-product/components/AddProductsToCart/UseAddProductsToCartAction.gql'
import { Trans } from "@lingui/react";
import { i18n } from '@lingui/core'
import { Link } from '@mui/material'

type ProductSidebarPreOrderProps = {
  preOrder?: number | null
  preOrderText?: string | null
}

export function ProductSidebarPreOrder(props: ProductSidebarPreOrderProps) {
  const {  preOrderText } = props

  let title = i18n._(/* i18n */ 'Pre-order')
  let subtitle: JSX.Element | string = <Link href='/service/shipping' color='textPrimary' underline='always'>
    <Trans id={preOrderText ?? 'The shipment will be made when the product is available.'} />
  </Link>

  return (
    <Box
      sx={(theme) => ({
        display: 'grid',
        alignItems: 'center',
        gridTemplate: `
          "image title"
          ".     subtitle"
        `,
        gridTemplateColumns: `min-content auto`,
        columnGap: theme.spacings.xxs,
        background:
          theme.palette.mode === 'light'
            ? darken(theme.palette.background.default, 0.01)
            : lighten(theme.palette.background.default, 0.2),
        padding: theme.spacings.xxs,
        ...breakpointVal(
          'borderRadius',
          theme.shape.borderRadius * 3,
          theme.shape.borderRadius * 4,
          theme.breakpoints.values,
        ),
      })}
    >
      <IconSvg src={iconOrderBefore} size='small' sx={{ gridArea: 'image' }} />
      <Box sx={{ typography: 'body2', gridArea: 'title', fontWeight: 600 }}>{title}</Box>
      <Box sx={{ typography: 'body2', gridArea: 'subtitle', color: 'text.primary' }}>
        {subtitle}
      </Box>
    </Box>
  )
}
